import TermsCondition from "./TermsCondition";

export default TermsCondition;
